import initModal from "./modal";
import goToTop from "./go-to-top";
import initLangSelector from "./lang-selector";
import panels from "./panels";

window?.addEventListener("DOMContentLoaded", () => {
  initModal();
  goToTop();
  initLangSelector();
  panels();
});
